<style scoped>
.full-height-width-card {
  min-height: 100vh;
  width: 100vw;
}
.card_shadow {
  background: white 0% 0% no-repeat padding-box;
  box-shadow: 8px 8px 23px #b9b9b9, -8px -8px 23px #ffffff !important;
}
.title {
  font: normal normal normal 24px/36px Roboto;
}
.filled_noline >>> .v-input__slot::before {
  border-style: none !important;
}
.under-line {
  text-decoration: underline;
}
</style>

<template>
  <v-card
    color="transparent"
    flat
    class="full-height-width-card align-center justify-center"
  >
    <v-row justify="center" v-show="showMain">
      <v-col cols="10">
        <v-card class="ma-10 card_shadow align-center justify-center">
          <v-form
            @submit.prevent="onClickSignIn"
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-container class="pa-13">
              <v-row justify="center">
                <p class="title">{{ $t('common.langxConsole') }}</p>
              </v-row>
              <v-row justify="center" class="mt-0">
                <p class="title">{{ $t('signIn.signIn') }}</p>
              </v-row>
              <v-row v-if="isSignInError" justify="center">
                <v-col cols="10">
                  <v-alert icon="mdi-alert-circle" type="error">
                    {{ signInErrorMessage }}
                  </v-alert>
                </v-col>
              </v-row>
              <v-row justify="center" class="mt-7">
                <v-col cols="10">
                  <v-text-field
                    v-model="email"
                    :label="$t('common.email')"
                    persistent-placeholder
                    outlined
                    required
                    @focus="clearSignInError"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center" class="mt-n7">
                <v-col cols="10">
                  <v-text-field
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                    v-model="password"
                    :label="$t('common.password')"
                    filled
                    dense
                    required
                    class="filled_noline"
                    @focus="clearSignInError"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-btn
                  :disabled="inputed"
                  color="#1b2643"
                  class="mb-10 white--text"
                  type="submit"
                >
                  {{ $t('signIn.signIn') }}
                </v-btn>
              </v-row>
              <v-row justify="center" class="mt-n7">
                <v-btn
                  text
                  color="blue"
                  class="ma-4 under-line"
                  @click="
                    clearSignInError()
                    clearInputText()
                    showMain = !showMain
                  "
                >
                  {{ $t('signIn.forgotPasswordButton') }}
                </v-btn>
              </v-row>
              <v-row justify="center" class="mt-n7">
                <v-btn
                  text
                  color="blue"
                  class="ma-4 under-line"
                  @click="goToSignUp"
                >
                  {{ $t('signIn.signUpHereButton') }}
                </v-btn>
              </v-row>
            </v-container>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center" v-show="!showMain">
      <v-col cols="10">
        <v-card class="ma-10 card_shadow align-center justify-center">
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent="onClickForgetPass()"
          >
            <v-container class="pa-13">
              <v-row justify="center">
                <p class="title">{{ $t('common.langxConsole') }}</p>
              </v-row>
              <v-row justify="center" class="mt-0">
                <p class="title">{{ $t('signIn.passwordResetEmailSend') }}</p>
              </v-row>
              <v-row v-if="emailNotFound" justify="center" class="mb-n7">
                <v-col cols="10">
                  <v-alert icon="mdi-alert-circle" type="error">
                    {{ $t('signIn.emailNotFound') }}
                  </v-alert>
                </v-col>
              </v-row>
              <v-row justify="center" class="mt-7">
                <v-col cols="10">
                  <v-text-field
                    v-model="email"
                    :label="$t('common.email')"
                    persistent-placeholder
                    outlined
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-btn
                  :disabled="inputed"
                  color="#1b2643"
                  class="mb-10 white--text"
                  type="submit"
                >
                  {{ $t('signIn.sendEmail') }}
                </v-btn>
              </v-row>
              <v-row justify="center" class="mt-n7">
                <v-btn
                  text
                  color="blue"
                  class="ma-4 under-line"
                  @click="
                    emailNotFound = false
                    clearInputText()
                    showMain = !showMain
                  "
                >
                  {{ $t('signIn.returnToSignInScreen') }}
                </v-btn>
              </v-row>
            </v-container>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <div class="d-flex justify-center">
      <language-switching color="black">
        <template v-slot:activator="{ attrs, on }">
          <v-btn large outlined v-bind="attrs" v-on="on">
            <v-icon left>mdi-translate</v-icon>
            <v-list-item-title>{{
              $t('common.languageSwitching')
            }}</v-list-item-title>
          </v-btn>
        </template>
      </language-switching>
    </div>

    <v-form>
      <v-container>
        <snack-bar
          :snackbarAction="isSnackbarAction"
          :snackbarText="snackbarTextInput"
          :snackbarColor="snackbarColorInput"
          @closeSnackbar="closeSnackbar"
        />
      </v-container>
    </v-form>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from "@vue/composition-api";
import {
  getAuth,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import LanguageSwitching from "@/components/Common/LanguageSwitchingComponent.vue";
// import store from '@/store'
import SnackBar from "@/components/Dashboard/PageViewItems/SnackbarComponent.vue";
import { auth } from "@/plugins/firebase";

export default defineComponent({
  name: "SignInView",
  components: {
    SnackBar,
    LanguageSwitching,
  },
  data() {
    return {
      valid: true,
      inputed: false,
      vertical: true,
      email: "",
      password: "",
      showPassword: false,
      showMain: true,
      isSnackbarAction: false,
      snackbarColorInput: "pink",
      isSignInError: false,
      snackbarTextInput: "",
      signInErrorType: "default" as
        | "default"
        | "not_accepted"
        | "session_expired",
      emailNotFound: false,
    };
  },

  computed: {
    signInErrorMessage(): string {
      if (this.signInErrorType === "not_accepted") {
        return this.$t("signIn.accountNotAccepted") as string;
      }
      if (this.signInErrorType === "session_expired") {
        return this.$t("signIn.sessionExpired") as string;
      }
      return this.$t("signIn.incorrectUsernameOrPassword") as string;
    },
  },

  watch: {
    "$store.state.authError"(newError: string | null) {
      if (newError === "not_accepted") {
        this.signInErrorType = "not_accepted";
        this.isSignInError = true;
        // Clear the error from the store
        this.$store.commit("setAuthError", null);
      } else if (newError === "session_expired") {
        this.signInErrorType = "session_expired";
        this.isSignInError = true;
        // Clear the error from the store
        this.$store.commit("setAuthError", null);
      }
    },
  },

  props: {
    snackbarAction: { type: Boolean, default: false },
    snackbarText: { type: String, default: "" },
    snackbarColor: { type: String, default: "" },
  },

  created() {
    // Check for auth error BEFORE resetting store
    const authError = this.$store.getters.authError;
    if (authError === "not_accepted") {
      this.signInErrorType = "not_accepted";
      this.isSignInError = true;
    } else if (authError === "session_expired") {
      this.signInErrorType = "session_expired";
      this.isSignInError = true;
    }

    // Clear authError immediately after consuming it to prevent stale errors
    // on subsequent visits (reset mutation preserves authError by design)
    if (authError) {
      this.$store.commit("setAuthError", null);
    }

    // サインイン画面を開くと強制サインアウトおよびストレージのリセット
    signOut(auth).then(() => {
      // Clear all localStorage data that could contain user information
      localStorage.removeItem("accessToken");
      localStorage.removeItem("langx-customer-console");
      // Don't remove language preference to maintain UX

      // Reset store state
      this.$store.commit("reset", this.$store.state);

      // Clear API client authorization
      this.$store.dispatch("clearApiClient");
    });
  },

  mounted() {
    // マウント完了後にprops読み込み -> データの変更を検知させる(createdだとSnackBarが変更を検知しない)
    this.isSnackbarAction = this.snackbarAction;
    this.snackbarColorInput = this.snackbarColor;
    this.snackbarTextInput = this.snackbarText;
  },

  methods: {
    onClickSignIn() {
      signInWithEmailAndPassword(auth, this.email, this.password)
        .then(async (user) => {
          const idTokenResult = await user.user.getIdTokenResult(true);
          // auth認証結果のトークン内のカスタムクレーム情報からroleを参照しrole=manager, email_verified=true, customerId!=falseの場合のみサインイン可能
          if (!idTokenResult.claims["email_verified"]) {
            this.isSignInError = true;
            return;
          } else {
            // 以下のthis.$store.commitの箇所は必要最低限のものまで削減する余地あり（頻度の低い変数はauthから直接参照など）
            this.$store.commit("setIdToken", idTokenResult);
            this.$store.commit("setUid", user.user.uid);
            this.$store.commit("setEmail", user.user.email);

            const navigateAfterAuth = () => {
              const redirectPath = this.$route.query.redirect
                ? decodeURIComponent(this.$route.query.redirect as string)
                : "/dashboard/signout";

              const resolvedRoute = this.$router.resolve(redirectPath);
              if (
                resolvedRoute.resolved.matched.length === 0 ||
                resolvedRoute.route.path !== redirectPath
              ) {
                this.$router.push("/dashboard/signout").catch((err) => {
                  // Ignore NavigationDuplicated errors
                  if (err.name !== "NavigationDuplicated") {
                    throw err;
                  }
                });
              } else {
                this.$router.push(redirectPath).catch((err) => {
                  // Ignore NavigationDuplicated errors
                  if (err.name !== "NavigationDuplicated") {
                    throw err;
                  }
                });
              }
            };

            // Check if already authenticated (synchronous check)
            if (this.$store.getters.authStatus === "authenticated") {
              navigateAfterAuth();
            } else {
              // Wait for authStatus to become 'authenticated' before navigating
              // This ensures the isAccepted check in App.vue completes first
              const unwatch = this.$store.watch(
                (state) => state.authStatus,
                (newStatus) => {
                  if (newStatus === "authenticated") {
                    unwatch();
                    navigateAfterAuth();
                  } else if (newStatus === "unauthenticated") {
                    // User was rejected (not accepted), unwatch and don't navigate
                    // The error will be shown via the watcher on authError
                    unwatch();
                  }
                },
              );
            }
          }
        })
        .catch((error) => {
          console.error("error code:", error.code);
          this.isSignInError = true;
        });
    },
    async onClickForgetPass() {
      const auth = getAuth();
      const url = `${window.location.origin}/reset-password`;

      try {
        await sendPasswordResetEmail(auth, this.email, { url });
        this.$router.push({
          name: "Check Email",
          query: { email: this.email },
        });
        this.showMain = !this.showMain;
        this.emailNotFound = false;
        this.clearInputText();
      } catch (error) {
        const code = (error as { code: string }).code;
        console.error("err code: ", code);
        if (code === "auth/user-not-found" || code === "auth/invalid-email") {
          this.emailNotFound = true;
        } else {
          this.isSignInError = true;
          this.signInErrorType = "default";
        }
      }
    },
    clearSignInError() {
      this.isSignInError = false;
      this.signInErrorType = "default";
    },
    clearInputText() {
      this.email = "";
      this.password = "";
    },
    goToSignUp() {
      this.$router.push({ name: "Sign Up" });
    },
    closeSnackbar() {
      this.isSnackbarAction = false;
    },
  },
});
</script>
